<!-- 新增用户 -->
<template>
  <div>
    <!-- 身份校验 -->
    <h-msg-box v-model="checkIdentity" title="验证身份" :width="550" allowCopy :mask-closable="false" class="msg-form-box"
      @on-close="handleClose('checkIdentityFormRef')">
      <h-form ref="checkIdentityFormRef" class="mt-20" :model="checkIdentityFormModel" :label-width="150"
        label-position="right">
        <h-form-item label="企业账号管理员姓名" prop="phone">
          {{ adminUserInfo.user_name }}
        </h-form-item>
        <h-form-item label="企业账号安全手机" prop="phone">
          <h-radio class="check-radio" v-model="checkIdentityFormModel.type" true-value="1" false-value="2"
            @on-change="changeIdentityType" :disabled="!accountInfo.contact_mobile_tel"></h-radio>
          {{ accountInfo.contact_mobile_tel }}
        </h-form-item>

        <h-form-item label="企业账号安全邮箱" prop="email">
          <h-radio class="check-radio" v-model="checkIdentityFormModel.type" true-value="2" false-value="1"
            @on-change="changeIdentityType" :disabled="!accountInfo.email"></h-radio>
          {{ accountInfo.email }}
        </h-form-item>
        <h-form-item prop="captcha_sms_code" label="验证码" style="width:480px;">
          <h-input v-model="checkIdentityFormModel.captcha_sms_code" type="text" placeholder="请输入验证码" autocomplete="off"
            special-filter :special-decimal="0" :special-length="6" />
          <div class="message-div" :class="{
              'secondes-message': !resendShow
            }" @click="getIdentityCheckCode('checkIdentityFormRef')">
            {{ !resendShow ? "发送验证码" : `${qrSeconds}秒后可重发` }}
          </div>
        </h-form-item>
        <p class="tip">1、接收验证码的手机号为您所在企业账号的管理员手机号</p>
        <p class="tip">2、发送验证码后，您可以在手机短信中获取（5分钟有效）</p>
      </h-form>
      <div slot="footer">
        <h-button type="ghost" @click="handleClose('checkIdentityFormRef')">
          取消
        </h-button>
        <h-button type="primary" @click="submitForm('checkIdentityFormRef')">
          确定
        </h-button>
      </div>
    </h-msg-box>
  </div>
</template>
<script>
  import { get_check_code } from "@/api/login.js";
  import { getEnterpriseAccount, identityCheck } from "@/api/service.js";
  import common from "@/utils";
  import { mapGetters } from "vuex";
  export default {
    name: "bindEmail",
    props: {
      show: Boolean,
      initData: {
        type: Object,
        default: () => {
          return {};
        }
      }
    },
    computed: {
      ...mapGetters(["loginInfo"])
    },
    data() {
      return {
        checkIdentity: false,
        //身份校验请求参数
        checkIdentityFormModel: {
          type: "1",
          email: "",
          phone: "",
          captcha_sms_code: ""
        },
        checkCodeActive: false,
        resendShow: false,
        qrSeconds: 60,
        timer: null,
        adminUserInfo: {},
        accountInfo:{}
      };
    },
    created() { },
    methods: {
      //获取企业账号管理员信息
      getAdminInfo() {
        getEnterpriseAccount({
          account_id: this.loginInfo.account_id
        }).then(res => {
          this.accountInfo = res||{}
          this.adminUserInfo = res.admin_user || {};
        });
      },
      //关闭
      handleClose(ref) {
        this.$refs[ref].resetFields();
        this.$emit("update:show", false);
      },

      changeIdentityType() {
        this.qrSeconds = 60;
        this.resendShow = false;
      },
      // 获取图形
      // 60s后重新发送验证码
      resendMessage() {
        this.resendShow = true;
        this.timer = null;
        this.qrSeconds = 60;
        this.timer = setInterval(() => {
          if (this.qrSeconds == 0) {
            this.resendShow = false;
            clearInterval(this.timer);
            return;
          }
          this.qrSeconds--;
        }, 1000);
      },
      // 绑定邮箱，先获取验证码
      handelBindEmail(ref) {
        if (this.resendShow) return;
        this.bindEmailFormModel.check_code = "";
        this.$refs[ref].validate(vali => {
          if (vali) {
            get_check_code(this.bindEmailFormModel.email, 9).then(res => {
              const { error_info } = res;
              if (error_info === "") {
                clearInterval(this.timer);
                this.$hMessage.success("验证码已发送至您的邮箱请前往确认");
                this.resendMessage();
              }else{
                this.$hMessage.error(error_info)
              }
            });
          }
        });
      },
      //获取短信/邮箱验证码
      getIdentityCheckCode() {
        if (this.resendShow) return;

        let phone, type;
        if (this.checkIdentityFormModel.type == "1") {
          phone = this.accountInfo.contact_mobile_tel;
          type = 12;
        } else {
          phone = this.accountInfo.email;
          type = 11;
        }
        get_check_code(phone,type).then(res => {
          const { error_info } = res;
          if (error_info === "") {
            clearInterval(this.timer);
            this.resendMessage();
          }else{
            this.$hMessage.error(error_info);
          }
        });
      },
      submitForm(ref) {
        this.$refs[ref].validate(vali => {
          if (vali) {
            //TODO 校验成功
            let phone, type;
            if (this.checkIdentityFormModel.type == "1") {
              phone = this.accountInfo.contact_mobile_tel;
              type = 12;
            } else {
              phone = this.accountInfo.email;
              type = 11;
            }
            identityCheck({
              phone_or_email: phone,
              check_code: this.checkIdentityFormModel.captcha_sms_code,
              captcha_sms_type: type
            }).then((res) => {
              if (res === null) {
                this.$hMessage.success("身份校验通过");
                this.$refs[ref].resetFields();
                this.checkIdentity = false;
                this.resendShow = false;
                this.qrSeconds = 60;
                this.$emit("success");
              }
            });

          }
        });
      }
    },
    watch: {
      show(newValue, oldValue) {
        if (newValue) {
          this.checkIdentityFormModel = {
            type: "1",
            email: "",
            phone: "",
            captcha_sms_code: ""
          }
          this.getAdminInfo();
          this.resendShow = false;
          this.qrSeconds = 60;
          clearInterval(this.timer);

        }
        this.checkIdentity = newValue;
      }
    }
  };
</script>
<style scoped lang="scss">
  .message-div {
    position: absolute;
    top: 0;
    right: 0;
    background: #e2e2e2;
    border: 1px solid #e2e2e2;
    width: 120px;
    height: 32px;
    border-radius: 0 6px 6px 0;
    text-align: center;
    font-family: PingFangSC-Regular;
    color: #ffffff;
    line-height: 32px;
    cursor: not-allowed;
  }

  .secondes-message {
    background: #3060ff;
    border: 1px solid #3060ff;
    cursor: pointer;
  }

  ::v-deep {
    .h-modal-body {
      padding: 10px 44px 16px 44px;
    }
  }

  /deep/ .h-form-item {
    margin-bottom: 0px;
  }

  .check-radio {
    position: absolute;
    left: -150px;
    line-height: 32px;
  }

  .tip {
    padding-left: 150px;
    margin-top: 4px;
  }
</style>


// WEBPACK FOOTER //
// src/gtn/views/frontViews/components/IdentityCheck.vue